import { faCaretLeft, faCaretRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

import { IMilestone } from "@/interfaces";
import { MilestoneActionButtons } from "./MilestoneActionButtons";
import { ActionDrawer, ToggleDrawerButton } from "./styled";

interface IProps {
  milestone: IMilestone;
  childLevel: number;
  maxChildLevel: number;
  parentId: string;
}

const MilestoneActionDrawer = ({
  milestone,
  childLevel,
  maxChildLevel,
  parentId,
}: IProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const roundedRightBorder = {
    borderBottomRightRadius: "8px",
    borderTopRightRadius: "8px",
  };

  return (
    <ActionDrawer open={drawerOpen} style={roundedRightBorder}>
      <ToggleDrawerButton
        style={
          drawerOpen ? { borderRight: "1px solid #808080" } : roundedRightBorder
        }
        data-test-id={`milestone-actions-drawer-toggle-${milestone.id}`}
        icon={
          drawerOpen ? (
            <FontAwesomeIcon
              style={{ color: "#448EEC", width: "6px", height: "10px" }}
              icon={faCaretRight}
            />
          ) : (
            <FontAwesomeIcon
              style={{ color: "#448EEC", width: "6px", height: "10px" }}
              icon={faCaretLeft}
            />
          )
        }
        onClick={() => setDrawerOpen(!drawerOpen)}
        type="text"
      />
      {drawerOpen && (
        <MilestoneActionButtons
          data-test-id={`milestone-actions-drawer-${milestone.id}`}
          milestone={milestone}
          childLevel={childLevel}
          maxChildLevel={maxChildLevel}
          parentId={parentId}
        />
      )}
    </ActionDrawer>
  );
};

export { MilestoneActionDrawer };
